import Grid from '@mui/material/Grid2';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Icon from '@mdi/react';
import { mdiArrowLeftThin } from '@mdi/js';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import Fab from '@mui/material/Fab';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { NavLink } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import { useState } from 'react';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { Iconify } from '@mgm/common/components';
import { BaseTooltip, BaseLink } from '@mgm/common/components/base';
import {
  TimesheetsMemberHeader,
  TimesheetsMemberTotal,
  TimesheetsMemberTable,
  CreateEditShift,
  DeleteShiftDialog,
  SheetsCardTour,
} from '../../features/timesheets';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { PageHelmet } from '../../components';
import { useAppDispatch } from '../../hooks/useAppStore';
import { commonActions } from '../../store/common/slice';
import { useSheetsPermissions } from '../../features/timesheets/hooks';

const TimesheetsMemberPage = () => {
  const { t } = useTranslation(['timesheets', 'common']);
  const [runTour, setRunTour] = useState(false);
  const dispatch = useAppDispatch();
  const { permissions } = useSheetsPermissions();

  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);

  const handleStartTour = () => {
    dispatch(commonActions.setIsOpenPagesNav(true));
    setRunTour(true);
  };

  return (
    <PageHelmet title={PAGES_ANALYTICS_TITLES.TIMESHEETS_CARD}>
      <Container
        sx={{
          px: { xs: 0, lg: 2 },
          position: 'relative',
        }}
        maxWidth={false}
      >
        <SheetsCardTour runTour={runTour} setRunTour={setRunTour} />
        {!isMobile ? (
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <BaseLink NavLinkComponent={NavLink} to="/timesheets">
              <Box paddingY={2} display="flex" justifyContent="start">
                <Icon className="mr-1" path={mdiArrowLeftThin} size={0.7} />
                {t('backToTimesheets')}
              </Box>
            </BaseLink>
            {permissions.isAllowManage && (
            <BaseTooltip tooltipText={t('clockHereToStartAGuided', { ns: 'common' })}>
              <Box
                sx={{
                  cursor: 'pointer',
                }}
                alignItems="center"
                display="flex"
                onClick={handleStartTour}
              >
                <Iconify icon="cuida:help-outline" width={24} sx={{ color: '#A855F7' }} />
              </Box>
            </BaseTooltip>
            )}
          </Stack>
        ) : (
          <Box top={-8} position="absolute" to="/timesheets" component={NavLink}>
            <Fab
              size="small"
              color="primary"
            >
              <ChevronLeft />
            </Fab>
          </Box>
        )}
        <Grid mt={isMobile ? 2 : 0} container spacing={3}>
          <Grid size={{
            xs: 12, md: 5, lg: 5, sm: 12,
          }}
          >
            <TimesheetsMemberHeader />
          </Grid>
          <TimesheetsMemberTotal />
          <Grid size={{ lg: 12, xs: 12 }}>
            <TimesheetsMemberTable />
          </Grid>
        </Grid>
        <DeleteShiftDialog />
        <CreateEditShift />
      </Container>
    </PageHelmet>
  );
};

export default TimesheetsMemberPage;
